export function getExceptionMessage(exception) {
  return `${exception.error?.message || exception.message || exception.toString()}`;
}
